import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        setUser(res.data);
        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true, state: { user: res.data } });
      } catch (err) {
        console.error('Auth error:', err);
        navigate('/login');
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#C5DB7B] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-[#6B655F] font-light">Signing you in...</p>
      </div>
    </div>
  );
}
